interface GoogleIconProps {
	className?: string
}

export function GoogleIcon({ className }: GoogleIconProps) {
	return (
		<svg viewBox="0 0 24 24" className={className} aria-hidden="true">
			<title>Google</title>
			<path
				fill="#EA4335"
				d="M12 10.2v3.92h5.46c-.24 1.27-.96 2.34-2.04 3.07v2.55h3.3c1.93-1.78 3.05-4.4 3.05-7.5 0-.7-.06-1.4-.18-2.04H12z"
			/>
			<path
				fill="#34A853"
				d="M12 22c2.76 0 5.07-.92 6.76-2.48l-3.3-2.55c-.92.6-2.08.96-3.46.96-2.66 0-4.92-1.8-5.72-4.22H2.85v2.65A10 10 0 0 0 12 22z"
			/>
			<path
				fill="#FBBC05"
				d="M6.28 13.7a6.04 6.04 0 0 1 0-3.4V7.65H2.85a10 10 0 0 0 0 8.7l3.43-2.65z"
			/>
			<path
				fill="#4285F4"
				d="M12 5.95c1.5 0 2.85.52 3.92 1.54L18.86 4.5A10 10 0 0 0 12 2 10 10 0 0 0 2.85 7.65l3.43 2.65C7.08 7.75 9.34 5.95 12 5.95z"
			/>
		</svg>
	)
}
